import { graphql, readInlineData } from 'react-relay';

import { type getHasEnoughSimilarSoldItems_viewer$key } from './__generated__/getHasEnoughSimilarSoldItems_viewer.graphql.ts';

const MIN_SIMILAR_SOLD_ITEMS = 3;

const viewerFragment = graphql`
    fragment getHasEnoughSimilarSoldItems_viewer on Viewer @inline {
        similarSoldItemsResults: similarSoldItems(itemId: $itemId, first: 0)
            @include(if: $isEstimateSimilarSoldVariant) {
            totalResults
        }
    }
`;

export const getHasEnoughSimilarSoldItems = ({
    viewer: viewerRef,
}: {
    viewer: getHasEnoughSimilarSoldItems_viewer$key | null;
}): boolean => {
    const viewer = readInlineData(viewerFragment, viewerRef);
    const totalResults = viewer?.similarSoldItemsResults?.totalResults || 0;

    return totalResults >= MIN_SIMILAR_SOLD_ITEMS;
};
